/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventpageunreadableerror3Inputs */

const en_eventpageunreadableerror3 = /** @type {(inputs: Eventpageunreadableerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page behind the link could not be read. Check the link or describe the event yourself.`)
};

const de_eventpageunreadableerror3 = /** @type {(inputs: Eventpageunreadableerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Seite hinter dem Link ließ sich nicht lesen. Prüf den Link oder beschreib das Event selbst.`)
};

/**
* | output |
* | --- |
* | "The page behind the link could not be read. Check the link or describe the event yourself." |
*
* @param {Eventpageunreadableerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventpageunreadableerror3 = /** @type {((inputs?: Eventpageunreadableerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventpageunreadableerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventpageunreadableerror3(inputs)
	return de_eventpageunreadableerror3(inputs)
});
export { eventpageunreadableerror3 as "eventPageUnreadableError" }